"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcCheckbox = _interopRequireDefault(require("rc-checkbox"));
var _inputHOC = _interopRequireDefault(require("../Form/inputHOC"));
var _shallowequal = _interopRequireDefault(require("shallowequal"));
var _ykbStyledComponents = require("../ykb-styled-components");
var _StyledRadio = require("./StyledRadio");
var _excluded = ["className", "children", "style", "textLabel"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var Radio = /*#__PURE__*/function (_React$Component) {
  function Radio() {
    var _this;
    (0, _classCallCheck2.default)(this, Radio);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Radio, [].concat(args));
    (0, _defineProperty2.default)(_this, "saveCheckbox", function (node) {
      _this.rcCheckbox = node;
    });
    return _this;
  }
  (0, _inherits2.default)(Radio, _React$Component);
  return (0, _createClass2.default)(Radio, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
      return !(0, _shallowequal.default)(this.props, nextProps) || !(0, _shallowequal.default)(this.state, nextState) || !(0, _shallowequal.default)(this.context.radioGroup, nextContext.radioGroup);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.rcCheckbox.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.rcCheckbox.blur();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = this.props,
        context = this.context;
      var className = props.className,
        children = props.children,
        style = props.style,
        textLabel = props.textLabel,
        restProps = (0, _objectWithoutProperties2.default)(props, _excluded);
      var radioGroup = context.radioGroup;
      var radioProps = _objectSpread({}, restProps);
      if (radioGroup) {
        radioProps.name = radioGroup.name;
        radioProps.onChange = radioGroup.onChange;
        radioProps.checked = props.value === radioGroup.value;
        radioProps.disabled = props.disabled || radioGroup.disabled;
      }
      return /*#__PURE__*/_react.default.createElement(_ykbStyledComponents.ThemeConsumer, null, function (theme) {
        var _radioGroup$vertical;
        return /*#__PURE__*/_react.default.createElement(_StyledRadio.StyledContainer, {
          theme: theme,
          checked: radioProps.checked,
          disabled: radioProps.disabled,
          selectionBox: radioProps.selectionBox,
          style: style,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave,
          cls: className,
          vertical: (_radioGroup$vertical = radioGroup === null || radioGroup === void 0 ? void 0 : radioGroup.vertical) !== null && _radioGroup$vertical !== void 0 ? _radioGroup$vertical : false
        }, function (styledPrefix) {
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_rcCheckbox.default, (0, _extends2.default)({}, radioProps, {
            prefixCls: styledPrefix,
            ref: _this2.saveCheckbox
          })), children !== undefined || textLabel !== undefined ? /*#__PURE__*/_react.default.createElement(_StyledRadio.StyledLabel, {
            $theme: theme
          }, textLabel || children) : null);
        });
      });
    }
  }]);
}(_react.default.Component);
(0, _defineProperty2.default)(Radio, "defaultProps", {
  type: 'radio',
  checked: false,
  disabled: false
});
(0, _defineProperty2.default)(Radio, "contextTypes", {
  radioGroup: _propTypes.default.any
});
Radio.propTypes = {
  /**
   * Additional CSS ui classes
   */
  className: _propTypes.default.string,
  children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.string]),
  textLabel: _propTypes.default.string,
  value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  checked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  defaultChecked: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.number]),
  onChange: _propTypes.default.func,
  type: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
var _default = exports.default = (0, _inputHOC.default)(Radio);